import { type StaticEncode, Type } from '@sinclair/typebox';
import type { PodcastGenre } from '../models/podcast-genres.js';
import { MongooseRefSchema, NullableDTO, TransformedRefToString } from './common.dto.js';
import { ItemDTOSchema } from './item.dto.js';
import { ItemUserPodcastDTOSchema } from './item-user.dto.js';
import { PodcastDTOSchema } from './podcast.dto.js';

export const PodcastEpisodeDTOSchema = Type.Composite([
  ItemDTOSchema,
  Type.Object({
    categories: Type.Optional(Type.Array(Type.Unsafe<PodcastGenre>(Type.String()))),
    channel: TransformedRefToString(MongooseRefSchema(PodcastDTOSchema)),
    estimatedDuration: Type.Number(),
    explicit: Type.Boolean(),
    itemUser: Type.Optional(NullableDTO(Type.Pick(ItemUserPodcastDTOSchema, ['listened', 'position']))),
    nbOfSpotlights: Type.Optional(Type.Number()),
  }),
]);

// export type PodcastEpisodeDTO = Omit<Static<typeof PodcastEpisodeDTOSchema>, 'channel'> & { channel: string };
export type PodcastEpisodeDTO = StaticEncode<typeof PodcastEpisodeDTOSchema>;
